module.exports = __webpack_public_path__ + "static/img/bannerApp3-2.3804784.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bannerApp3-2.jpg
// module id = hcT5
// module chunks = 1